module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 6-b9cfe9a74cb79455d7be61e2ff26b8dd.jpg";